"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoLogin = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const KEY = 'autoLogin';
const IDP_HINT_KEY = 'idpHint';
function useAutoLogin(authUrl) {
    const { search } = react_router_dom_1.useLocation();
    const params = react_1.useMemo(() => new URLSearchParams(search), [search]);
    const [shouldAutoLogin, setShouldAutoLogin] = react_1.useState(false);
    const urlWantsAutoLogin = react_1.useMemo(() => {
        return params.get(KEY) === 'true';
    }, [params]);
    const idpHint = react_1.useMemo(() => {
        return params.get(IDP_HINT_KEY);
    }, [params]);
    const history = react_router_dom_1.useHistory();
    react_1.useEffect(() => {
        if (urlWantsAutoLogin) {
            const search = new URLSearchParams(window.location.search);
            search.delete(KEY);
            history.push({
                search: search.toString(),
            });
            setShouldAutoLogin(true);
        }
    }, [authUrl, history, shouldAutoLogin, urlWantsAutoLogin]);
    react_1.useEffect(() => {
        if (shouldAutoLogin && authUrl) {
            const url = idpHint ? `${authUrl}&kc_idp_hint=${idpHint}` : authUrl;
            window.location.href = url;
        }
    }, [authUrl, idpHint, shouldAutoLogin]);
}
exports.useAutoLogin = useAutoLogin;
//# sourceMappingURL=useAutoLogin.js.map